var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMcrt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#CE3A6C",
    fillRule: "evenodd",
    d: "M12 18.429a6.428 6.428 0 1 0 0-12.857a6.428 6.428 0 0 0 0 12.857m0-.557a5.871 5.871 0 1 0 0-11.743a5.871 5.871 0 0 0 0 11.743",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF6FF",
    fillRule: "evenodd",
    d: "M12 18.103a6.107 6.107 0 1 0 0-12.21a6.107 6.107 0 1 0 0 12.214zm0 .15a6.253 6.253 0 1 0 0-12.506a6.253 6.253 0 0 0 0 12.506",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#602E9D",
    d: "M8.901 15.789c-.463.557-1.393 1.676-1.401 1.701c-.047-.06-.283-.047-.407.086a.3.3 0 0 0-.052.3l-.193.043l-.342 1.285l.098.082l1.256-.497l-.073-.266c.077-.004.253-.043.309-.137a.42.42 0 0 0 .025-.291l1.56-1.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#441C56",
    d: "m8.228 18.047l-.728-.664l.15-.171l.728.664zm.185-.248l-.729-.665l.154-.17l.729.668zm.253-.249l-.729-.664l.15-.171l.729.668zm.184-.201l-.729-.665l.155-.17l.728.668zM9 17.1l-.724-.664l.15-.171l.728.668zm.201-.244l-.728-.669l.154-.171l.729.669zm.27-.249l-.724-.668l.154-.167l.729.664zM7.427 17.7c-.163-.085-.3-.073-.347-.055c.026-.168.3-.19.403-.15c.103.038.471.467.578.56c.086.078.056.112.026.12c-.154-.12-.497-.385-.66-.47z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AE8FEC",
    d: "m7.988 18.437l-.711-.608c.129.026.416.107.574.244c.159.142.159.3.137.364m-1.414.789l.069-.214l.111.055l.814-.235l-.882.394z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F781FC",
    d: "m7.556 18.665l-.566-.485c0 .009 0 .03.013.06c.013.043.03.086.047.245c.017.158-.022.05-.034.094c-.018.043 0 .055-.065.073c-.064.021-.073.09-.111.158c-.034.056.013.095.043.103c.055-.06.184-.197.231-.236c.056-.047.112-.012.129-.012s.077-.026.137-.043c.047-.017.06.021.064.043z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#382671",
    d: "m9.48 14.465l-.244-.215l.338-.265l1.5 1.144l-.064.505l-.369-.17l-.3.222l-.947-.634z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D83F7F",
    d: "m9.626 15.013l.03-.42l.265.214zm.437-.051l-.369.197l.343.261zm.115.098l.048.442l.312-.197z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMcrt0)",
    d: "M12.171 17.143a5.1 5.1 0 0 0 3.082-1.029c-.022-.055-.022-.14-.026-.23a.6.6 0 0 0-.03-.24c-.026-.065.026-.07.077-.074c.086-.008.172-.017-.008-.227c.025-.086-.03-.111-.12-.103l-.155.137l-.025-.111c-.03-.107-.065-.09-.223-.009c-.266.133-.9.455-2.477.656c-2.006.253-3.515-1.221-4.012-1.989c.094.223.42.742 1.05 1.415a4.398 4.398 0 1 1 6.707-1.196a.5.5 0 0 0 .172.056c.128.017.231-.15.308-.382c-.025.215 0 .416.043.429c.06.021.343-.759.36-.896c.013-.085.013.356-.056.806a5.143 5.143 0 1 0-4.667 2.987m4.32-3.321c.009-.069.026-.142.043-.206q.098-.342.129-.694a4.4 4.4 0 0 1-.172.9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMcrt1)",
    d: "M8.773 13.59a.53.53 0 0 1-.617-.15c.124.857 1.015.866 1.448.763c.313.464.752.83 1.264 1.054c-.141 1.153.609 1.312.999 1.243c-.347-.613-.12-1.037.039-1.174L9.35 13.342c-.064.034-.27.128-.578.248"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D83F7F",
    d: "m9.343 13.5l-.047.48l.48-.158l-.438-.326zm1.813 1.577l-.043.48l.48-.154z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMcrt2)",
    d: "M11.061 12.395h-.398l.098.407h-.407l.077.33h-.373v.081h-.107v.197l.583.9l3.202-3.6l4.53-5.46l-.12-.107c-1.132.66-2.032.69-2.34.626l-4.393 5.811l-.497.395z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AFDDEA",
    d: "M10.663 12.395h.398l-.145-.42l.497-.395l1.26-1.663c.343.163.775.42.664.549c-.137.154-.613.043-.831-.034l-.558.643h.54c.06-.01.193.004.193.128c0 .163-.484.287-1.063.266l.596.951l-1.68 1.89l-.583-.9v-.197h.107v-.081h.373l-.077-.33h.407z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F3FFFD",
    d: "M15.244 6.514c.249-.055.6-.094.857.01c.343.136.493.342.485.75l1.68-2.024l-.12-.107c-1.132.66-2.032.69-2.34.626z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D89C7",
    d: "m12.467 13.603l.064.399l-.411-.035l.064.407l-.334-.02l.06.368l-.077.013l.017.11l-.193.03l-.973-.432l3.12-3.818L18.27 5.25l.128.103c-.462 1.243-.351 2.143-.235 2.443L13.2 13.114l-.3.566l-.437-.081z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#184BB9",
    d: "M16.466 7.427c.42-.334.921-.681 1.024-.565c.141.158.343.42.338 1.29l.335-.356c-.116-.3-.227-1.2.231-2.443l-.124-.103z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AA3D6",
    d: "m13.474 11.259l4.114-4.98a1404 1404 0 0 1-4.671 6.853c-.133.171-.304.3-.377.343h-.279v.398h-.355v.292h-.343v.342l-.45-.15l.385-.484l1.042-.664l-.163-.159l.54-.343l-.193-.188l.412-.283l-.129-.167l.471-.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedMcrt3)",
    d: "M10.997 13.217c-.107.309-.617.635-.857.759l.424.471l.433.24c0-.467.883-1.2 1.329-1.508l-.108-.12l.515-.399l-.215-.073l.442-.334l-.146-.073l.9-1.525l-1.277 1.19l-.12-.183l-.227.591l-.142-.257l-.278.664l-.154-.227l-.412.784h-.111z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1ED096",
    d: "m11.164 13.217l-.283.386l.472-.386h.145l1.586-1.817l-.668.647l-.103-.094l-.18.416h-.146l-.279.424l-.167-.086l-.265.51z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMcrt0",
    x1: 5.933,
    x2: 17.972,
    y1: 9.215,
    y2: 13.664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F3FEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DD2EE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMcrt1",
    x1: 11.39,
    x2: 13.644,
    y1: 11.544,
    y2: 9.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#21826F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#062F6F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMcrt2",
    x1: 12,
    x2: 13.8,
    y1: 9.5,
    y2: 10.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#B1E2EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#CFECF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#CDEAEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ADE0F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedMcrt3",
    x1: 9.518,
    x2: 11.82,
    y1: 12.943,
    y2: 15.166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#108550"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E4E4D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcrt);
export default __webpack_public_path__ + "static/media/mcrt.3031312c5c80e27b1aac9934a77a2b57.svg";
export { ForwardRef as ReactComponent };